


























import _ from 'lodash'
import { Component } from 'vue-property-decorator'
import ProfileComponent from '@/components/profile/Profile.vue'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { Action } from 'vuex-class'
import ExcludeDate from '@/components/profile/Excludedate.vue'

@Component({
  components: {
    ProfileComponent,
    ExcludeDate,
  },
})
export default class Profile extends VueExtendedBaseComponent {

  @Action('components/updateTitlePage')
  public updateTitlePage!: (title: string) => void

  private created() {
    this.updateTitlePage('ข้อมูลส่วนตัว')
  }

}
